import api from "api"

const certificate = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/certificate`)
    },
    create: (slug, payload) => {
        return api().post(`/events/detail/${slug}/certificate`, payload)
    },
    update: (slug, payload) => {
        return api().put(`/events/detail/${slug}/certificate`, payload)
    },
    delete: (slug) => {
        return api().delete(`/events/detail/${slug}/certificate`)
    },
    uploadBackground: (slug, formData) => {
        return api().post(`/events/detail/${slug}/certificate/background`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        })
    },
    download: (slug) => {
        return api().get(`/users/certificates/${slug}/download`, { responseType: 'blob' })
    }
}

export default certificate
